import { DatabaseOutlined, FileTextOutlined, InfoCircleFilled, SettingOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { DepartmentEn } from 'src/constants/department.enum';
import urlPath from 'src/constants/urlPath';
import { UserInfo } from 'src/types/master_data/employee.type';
import './ModulesMenu.scss';

const { Text } = Typography;

interface ModuleItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  url: string;
  requiredPath?: string;
  requiredDepartment?: DepartmentEn;
}

const domain = 'martech.com.vn';

// Danh sách modules
const modulesList: ModuleItem[] = [
  {
    id: '1',
    label: 'Helpdesk',
    icon: <InfoCircleFilled />,
    url: window.location.origin + urlPath.home.location
  },
  {
    id: '2',
    label: 'Interactive',
    icon: <SettingOutlined />,
    url: process.env.NODE_ENV === 'production' ? `https://interactive.${domain}` : `http://localhost:3000`
  },
  {
    id: '3',
    label: 'ERP',
    icon: <DatabaseOutlined />,
    url: process.env.NODE_ENV === 'production' ? `https://erp.${domain}` : `http://localhost:3030`
  },
  {
    id: '4',
    label: 'EDoc',
    icon: <FileTextOutlined />,
    url: process.env.NODE_ENV === 'production' ? `https://edoc.${domain}` : `http://localhost:3000`
  }
];

interface ModulesMenuProps {
  userInfo: UserInfo | null;
  isUserAdmin: boolean | undefined;
  paths: string[];
}

const ModulesMenu = ({ userInfo, isUserAdmin, paths }: ModulesMenuProps) => {
  const navigate = useNavigate();
  // Function để filter modules theo quyền
  const getAvailableModules = () => {
    return modulesList.filter((module) => {
      // Nếu có requiredPath, kiểm tra quyền
      if (module.requiredPath) {
        const hasPermission = paths?.includes(module.requiredPath) || isUserAdmin;
        return hasPermission;
      }

      // Nếu có requiredDepartment, kiểm tra department
      if (module.requiredDepartment) {
        if (userInfo?.departmentId !== module.requiredDepartment && !isUserAdmin) {
          return false;
        }
      }

      return true;
    });
  };

  const handleModuleClick = (module: ModuleItem) => {
    if (module.url.includes(window.location.origin)) {
      // Internal navigation
      const path = module.url.replace(window.location.origin, '');
      navigate(path);
    } else {
      // External navigation
      window.open(module.url, '_blank');
    }
  };

  const availableModules = getAvailableModules();

  return (
    <div className='modules-menu-grid'>
      {availableModules.map((module) => (
        <div key={module.id} className='module-grid-item' onClick={() => handleModuleClick(module)}>
          <div className='module-icon'>{module.icon}</div>
          <Text className='module-label'>{module.label}</Text>
        </div>
      ))}
    </div>
  );
};

export default ModulesMenu;
